module.exports = __webpack_public_path__ + "img/10-query-placements.46753a1d.png";